export const remapPaymentVendors = (paymentMethods) => paymentMethods.map((paymentMethod) => paymentMethod.key);
